$(document).ready(function(){


  //sticky header
//   var $header = $(".header-sticky-wrapper");

//   $(window).on("scroll", function() {

//     if(window.scrollY > 200) {
//       $header.addClass("header-sticky");
//       $(".site-header__logo-link img").each(function (){
//       	$(this).attr("src", "https://cdn.shopify.com/s/files/1/0329/9577/0508/files/logo-01.png?v=1605545826");
//         $(this).attr("srcset", "https://cdn.shopify.com/s/files/1/0329/9577/0508/files/logo-01.png?v=1605545826");
//       });
//     }
//     else {
//       $header.removeClass("header-sticky");
//       $(".site-header__logo-link img:first-child").attr("src", "//cdn.shopify.com/s/files/1/0329/9577/0508/files/logo-f_260x.png?v=1597059924");
//       $(".site-header__logo-link img:first-child").attr("srcset", "//cdn.shopify.com/s/files/1/0329/9577/0508/files/logo-f_260x.png?v=1597059924 1x, //cdn.shopify.com/s/files/1/0329/9577/0508/files/logo-f_260x@2x.png?v=1597059924 2x");
      
//       $(".site-header__logo-link img:last-child").attr("src", "//cdn.shopify.com/s/files/1/0329/9577/0508/files/logo-f_110x.png?v=1597059924");
//       $(".site-header__logo-link img:last-child").attr("srcset", "//cdn.shopify.com/s/files/1/0329/9577/0508/files/logo-f_110x.png?v=1597059924 1x, //cdn.shopify.com/s/files/1/0329/9577/0508/files/logo-f_110x@2x.png?v=1597059924 2x");
      
//     }
//   });
  
  
  //video button
  var overlay = document.getElementById('video__btn');
  var vid = document.getElementById('Mp4Video-1605551052d243937c');
  if(overlay != null){
     if(overlay.addEventListener){
         overlay.addEventListener("click", play, false)
     }else if(overlay.attachEvent){
         overlay.attachEvent("onclick", play)
     }

     function play() { 
         if (vid.paused){
             vid.play(); 
             overlay.className = "o";
         }else {
             vid.pause(); 
             overlay.className = "";
         }
     } 
  }
  
  //slider
  
  if($(window).width() > 768) {

      $("#lightSlider").lightSlider({
        item: 1,
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        slideMargin: 10,
 
        addClass: '',
        mode: "slide",
        useCSS: true,
        cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
        easing: 'linear', //'for jquery animation',////
 
        speed: 500, //ms'
        auto: true,
        loop: false,// zzzzzzzzzzzzzz stop infinte loop
        slideEndAnimation: true,
        pause: 4000,
 
        keyPress: false,
        controls: true,
        prevHtml: '',
        nextHtml: '',
 
        rtl:false,
        adaptiveHeight:false,
 
        vertical:false,
        verticalHeight:500,
        vThumbWidth:100,
 
        thumbItem:11,
        pager: true,
        gallery: false,
        galleryMargin: 5,
        thumbMargin: 5,
        currentPagerPosition: 'middle',
 
        enableTouch:true,
        enableDrag:true,
        freeMove:true,
        swipeThreshold: 40,
 
        responsive : [],
 
        onBeforeStart: function (el) {},
        onSliderLoad: function (el) {},
        onBeforeSlide: function (el) {},
        onAfterSlide: function (el) {},
        onBeforeNextSlide: function (el) {},
        onBeforePrevSlide: function (el) {}
    });  
  }
  else {
   $("#lightSlider").lightSlider({
        item: 1,
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        slideMargin: 10,
 
        addClass: '',
        mode: "slide",
        useCSS: true,
        cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
        easing: 'linear', //'for jquery animation',////
 
        speed: 500, //ms'
        auto: true,
        loop: false,// zzzzzzzzzzzzz stop infinte loop
        slideEndAnimation: true,
        pause: 4000,
 
        keyPress: false,
        controls: true,
        prevHtml: '',
        nextHtml: '',
 
        rtl:false,
        adaptiveHeight:true,
 
        vertical:false,
        verticalHeight:500,
        vThumbWidth:100,
 
        thumbItem:10,
        pager: true,
        gallery: false,
        galleryMargin: 5,
        thumbMargin: 5,
        currentPagerPosition: 'middle',
 
        enableTouch:true,
        enableDrag:true,
        freeMove:true,
        swipeThreshold: 40,
 
        responsive : [],
 
        onBeforeStart: function (el) {},
        onSliderLoad: function (el) {},
        onBeforeSlide: function (el) {},
        onAfterSlide: function (el) {},
        onBeforeNextSlide: function (el) {},
        onBeforePrevSlide: function (el) {}
    });  
  }
  
 
  $(".lSAction").appendTo("#CollectionSection-16055578735fd84317 .page-width:last-child");
  $(".lSAction a").css({"top": "unset", "margin-top": "-35%"});
  $(".lSAction > .lSNext").css({"right": "8vw"});
  $(".lSAction > .lSPrev").css({"left": "10vw"});
  
  
});